export default __webpack_public_path__ + "static/media/detailsIcon.8a308475.svg";